import { useCallback, useRef } from 'react';
import { Flex } from '@banhala/ui-kit';
import { type LayoutChangeEvent } from 'react-native';

export const SectionContainer = (props: {
  children: React.ReactElement<{ isSkeleton: boolean }>;
  height?: number;
  onChangeHeight: (height: number) => void;
}) => {
  const { onChangeHeight } = props;
  const heightRef = useRef(0);

  const handleLayout = useCallback(
    ({ nativeEvent }: LayoutChangeEvent) => {
      const nextHeight = Math.round(nativeEvent.layout.height);
      if (heightRef.current !== nextHeight) {
        heightRef.current = nextHeight;
        onChangeHeight(nextHeight);
      }
    },
    [onChangeHeight],
  );

  return (
    <Flex height={props.height} onLayout={handleLayout}>
      {props.children}
    </Flex>
  );
};
